import { TableParams } from '../types';
export const scheduleDepositionTypes = {
  GET_SCHEDULE_DEPOSITIONS: 'GET_SCHEDULE_DEPOSITIONS',
  UPDATE_SCHEDULE_DEPOSITION: 'UPDATE_SCHEDULE_DEPOSITION',
};

export type GetScheduleDepositionsParam = TableParams & { [key: string]: string };

export type UpdateScheduleDepositionPayload = {
  name: string;
  email: string;
  lawFirm: string;
  phoneNumber: string;
  attorneyName: string;
  depositionDate: string;
  depositionLocation: string;
  city: string;
  isNeedConferenceRoom: boolean;
  caseName: string;
  deponent: string;
  additionalNotes: string;
};

export type ScheduleDepositionListItem = {
  updatedDate: string;
  id: string;
  name: string;
  email: string;
  lawFirm: string;
  phoneNumber: string;
  attorneyName: string;
  depositionDate: string;
  depositionLocation: string;
  city: string;
  isNeedConferenceRoom: boolean;
  caseName: string;
  deponent: string;
  additionalNotes: string;
  updatedByUserId: string | number | null;
  uri: string;
};
